import { render, staticRenderFns } from "./ModalInfo.vue?vue&type=template&id=22bb0a21&"
import script from "./ModalInfo.vue?vue&type=script&lang=js&"
export * from "./ModalInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports